import React from "react";
import { useTheme } from "styled-components";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteForgeNarrativeTranslateModalButton = React.lazy(
    () => import("adsForgeMfc/NarrativeTranslateModalButton"),
) as React.FC<any>;

export const ForgeNarrativeTranslateModalButton: React.FC<any> = (props) => {
    const theme = useTheme();

    return (
        <RemoteComponentWrapper>
            <RemoteForgeNarrativeTranslateModalButton
                {...props}
                modalElementId="ihub-portal"
                theme={theme}
            />
        </RemoteComponentWrapper>
    );
};
